import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras } from '@angular/router';
import { Subscription } from 'rxjs';

import { CerAppRouteService } from '../cer-app-route/cer-app-route.service';


@Component({
    selector: 'cer-app-notification',
    template: '<div>{{status}}</div>'
})
export class CerAppNotificationComponent implements OnDestroy, OnInit {
    private subscriptionManager$: Subscription = new Subscription();
    protected status: string = "Åbner";

    constructor(
        private activatedRoute: ActivatedRoute,
        private routerService: CerAppRouteService
    ) {
    }

    ngOnInit(): void {
        this.subscriptionManager$.add(
            this.activatedRoute.queryParamMap.subscribe(params => this.navigate(params))
        );
    }

    ngOnDestroy(): void {
        this.subscriptionManager$.unsubscribe();
    }

    private navigate(params: any) {
        var id: number = params?.get("id") ? Number(params.get("id")) : null;
        if (id != null) {
            this.status = 'Navigerer';
            this.dataNotificationNavigate(id);
        }
        else {
            this.status = 'Notifikation er ikke angivet';
        }
    }

    public dataNotificationNavigate(id: number) {
        this.routerService.redirectToUrl('warehouse/product-list?notificationId='+id.toString());
    }

}
